/**
 * The now line's minute (`docs/activity.md` §6.1, T31): the server's *now*
 * when it answered, moved on by this browser's clock since, and read again
 * every 30 s — so a calendar left open all morning keeps its line, and its
 * past tint, where the day actually is.
 */
import { useEffect, useMemo, useState } from 'react'
import { zonedLocal, type CalendarAnswer } from '@rowted/shared'

export function useNowMinutes(answer: CalendarAnswer | null): number {
  const answeredAt = useMemo(() => (answer ? Date.now() : 0), [answer])
  const [, setTick] = useState(0)
  useEffect(() => {
    const timer = window.setInterval(() => setTick((n) => n + 1), 30_000)
    return () => window.clearInterval(timer)
  }, [])
  if (!answer) return 0
  const said = Date.parse(answer.now)
  if (Number.isNaN(said)) return answer.nowMinutes
  return zonedLocal(new Date(said + (Date.now() - answeredAt)), answer.timeZone).minutes
}
